module.exports = __webpack_public_path__ + "static/media/profile-icon-bar.8eeddc3e.svg";